module.exports = __webpack_public_path__ + "img/mailIcon.7356272f.png";